export default "__VITE_ASSET__9fUeTDHj__";